var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9375 0H14.0625C6.25 0 0 6.25 0 14.0625V35.9375C0 43.75 6.25 50 14.0625 50H35.9375C43.75 50 50 43.75 50 35.9375V14.0625C50 6.25 43.75 0 35.9375 0Z",
    fill: "#3A559F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.875 24.0625C41.5625 23.75 41.0938 23.4375 40.625 23.4375H32.8125V17.5C32.8125 17.3437 32.9688 17.1875 33.125 17.1875H39.0625C40 17.1875 40.625 16.5625 40.625 15.625V10.9375C40.625 10 40 9.375 39.0625 9.375H32.8125C27.6562 9.375 25 13.5938 25 18.75V23.4375H18.75C17.8125 23.4375 17.1875 24.0625 17.1875 25V29.6875C17.1875 30.625 17.8125 31.25 18.75 31.25H25V50H32.8125V31.25H37.5C38.125 31.25 38.75 30.9375 38.9062 30.3125L42.0312 25.625C42.3438 25.1562 42.1875 24.5312 41.875 24.0625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.44403d4e968f799b3dd27a7eb54b7541.svg";
export { ForwardRef as ReactComponent };